import {lockBody, toggleLockBody, unlockBody} from "../_functions";

const {__} = wp.i18n
document.addEventListener('DOMContentLoaded', function (dom) {
    const jsMenu = dom.target.querySelector('.js-menu')
    const jsMenuToggle = dom.target.querySelector('.js-menu-toggle')

    if (jsMenu && jsMenuToggle) {
        const jsMenuReturn = dom.target.querySelectorAll('.js-menu-return')
        const jsMenuOverlay = dom.target.querySelector('.js-menu-overlay')
        const jsMenuServicesToggle = jsMenu.querySelector('.js-menu-services-toggle')
        const jsMenuServicesToggleDesk = dom.target.querySelector('.header__container-desk .js-menu-services-toggle')
        const jsMenuServices = dom.target.querySelector('.js-menu-services')
        const jsMenuInterventionAreasToggle = jsMenu.querySelector('.js-menu-intervention-areas-toggle')
        const jsMenuInterventionAreasToggleDesk = dom.target.querySelector('.header__container-desk .js-menu-intervention-areas-toggle')
        const jsMenuInterventionAreas = dom.target.querySelector('.js-menu-intervention-areas')

        const jsMenuToggleIcon = jsMenuToggle.querySelector('.vn-icons')
        jsMenuToggle.addEventListener('click', function (e) {
            jsMenuToggle.parentElement.parentElement.querySelector('.container-mob__left').classList.toggle('g-col-9')
            jsMenuToggle.parentElement.parentElement.querySelector('.container-mob__left').classList.toggle('g-col-7')
            jsMenuToggle.parentElement.classList.toggle('g-col-5')
            jsMenuToggle.parentElement.parentElement.classList.toggle('is-active')
            const isActive = jsMenuToggle.classList.contains('active')
            jsMenuToggleIcon.classList.toggle('vn-icons-menu')
            jsMenuToggleIcon.classList.toggle('vn-icons-close')
            jsMenuToggle.title = isActive ? __('Close', 'vn') : __('Menu', 'vn')
            toggleLockBody()
            jsMenu.classList.toggle('active')
            jsMenuServices.classList.remove('active');
            jsMenuInterventionAreas.classList.remove('active');
        })


        if (jsMenuReturn.length > 0) {
            jsMenuReturn.forEach((e) => {
                e.addEventListener('click', function (l) {
                    jsMenuReturn.forEach((i) => {
                        i.classList.remove('active')
                    })
                    jsMenuServices.classList.remove('active');
                    jsMenuInterventionAreas.classList.remove('active');
                })
            })
        }

        if (jsMenuServices && jsMenuServicesToggle && jsMenuServicesToggleDesk) {
            const openServicesMenu = (isHover = false) => {
                const isActive = jsMenuServices.classList.contains('active')
                jsMenuReturn.forEach((e) => {
                    e.classList.toggle('active')
                })

                if (isHover) {
                    lockBody()
                }

                if ((isHover && !isActive) || (!isHover)) {
                    jsMenuOverlay.classList.add('active');
                    jsMenuServicesToggle.title = isActive ? __('Close', 'vn') : __('Menu', 'vn')
                    jsMenuServices.classList.toggle('active')
                    jsMenuInterventionAreas.classList.remove('active')
                }
            }

            jsMenuServicesToggle.addEventListener('click', openServicesMenu)
            jsMenuServicesToggleDesk.addEventListener('mouseenter', () => openServicesMenu(true))
            jsMenuOverlay.addEventListener('mouseenter', () => {
                unlockBody()
                jsMenuServices.classList.remove('active')
                jsMenuOverlay.classList.remove('active');
            })
        }

        if (jsMenuInterventionAreasToggle && jsMenuInterventionAreas && jsMenuInterventionAreasToggleDesk) {
            const openInterventionAreasMenu = (isHover = false) => {
                const isActive = jsMenuInterventionAreas.classList.contains('active')
                jsMenuReturn.forEach((e) => {
                    e.classList.toggle('active')
                })

                if (isHover) {
                    lockBody()
                }

                if ((isHover && !isActive) || (!isHover)) {
                    jsMenuOverlay.classList.add('active');
                    jsMenuInterventionAreasToggle.title = isActive ? __('Close', 'vn') : __('Menu', 'vn')
                    jsMenuInterventionAreas.classList.toggle('active')
                    jsMenuServices.classList.remove('active')
                }
            }
            jsMenuInterventionAreasToggle.addEventListener('click', openInterventionAreasMenu)
            jsMenuInterventionAreasToggleDesk.addEventListener('mouseenter', () => openInterventionAreasMenu(true))
            jsMenuOverlay.addEventListener('mouseenter', () => {
                unlockBody()
                jsMenuInterventionAreas.classList.remove('active')
                jsMenuOverlay.classList.remove('active');
            })
        }
    }
})
